const RESOURCE_NAME = '/insurance-forms';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
});